import { SHOW_LOADING_SPINNER } from 'state/actionTypes';

export default isLoading => ({
  type: SHOW_LOADING_SPINNER,
  payload: isLoading,
});
